import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const QnA009 = ({ isOpened, onChangeOpenedFlag }) => {
    const { t } = useTranslation();

    useEffect(() => {
        let content = document.getElementById("qna09");

        if (isOpened) {
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = null;
        }
    }, [isOpened]);

    return (
        <div className="accordion">
            <div className="accordion-title" onClick={() => onChangeOpenedFlag(8)}>
                <span className="hiclasstv-deepDarkgrey-text button">
                    <b>9. {t("FAQ_질문_9", { ns: "info" })}</b>
                </span>
            </div>
            <div className="accordion-content hiclasstv-darkgrey-text" id="qna09">
                <span className="d-flex" style={{ minWidth: 'max-content' }}>A.&nbsp;</span>
                <p>
                    {t("FAQ_질문_9_답변_1", { ns: "info" })}<br />
                </p>
            </div>
        </div>
    );
}

export default QnA009;